<template>
    <!-- 忘記密碼的重設密碼 -->
    <div class="login">
        <navigation-bar Close/>
        <div class="main-content">
            <div class="logo"><Logo/></div>
            <el-form class="textBox" :model="form" ref="loginForm">
                <el-form-item>
                    <el-input placeholder="請輸入 6-12 碼英數混合" v-model="form.password" type="password"
                              maxlength="12"
                              autocomplete="off"
                              show-password/>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="請再次確認新密碼" v-model="form.reconfirm" type="password"
                              maxlength="12"
                              autocomplete="off"
                              show-password/>
                </el-form-item>
            </el-form>
            <div class="btn_box">
                <el-button round type="warning" @click="submit()">送出</el-button>
            </div>
        </div>
        <comm-dialog :value="dialog.isShowDialog" :outerContent="dialog.dialogMsg"  :isCancel="dialog.cancelable" @result="onCommDialogClose"/>
        <toast/>
        <div class="brand" v-if="!isWeb">
            <span>LIFE LINK 串門子品牌服務系統</span>
        </div>
    </div>
</template>

<script>
    import {checkPhone, checkPassword} from '@/util/validators';
    import Toast from '@/components/Toast.vue';
    import {SHOW_TOAST} from "@/store/mutationTypes";
    import CommDialog from "@/components/CommDialog";
    import Logo from "@/components/Logo";
    export default {
        name: "ResetPwd",
        components: {Toast, CommDialog , Logo},
        props: {
            isWeb: Boolean,
            dataTokenWeb: {default: ''},
        },
        data() {
            return {

                error: {
                    phone: false,
                    password: false,
                    timer: 0
                },
                form: {
                    oldPassword: '',
                    password: '',
                    reconfirm: ''
                },
                verifyForm: {
                    phone: this.isWeb? this.dataTokenWeb.phone :this.$route.query.phone,
                    verifyCode: this.isWeb? this.dataTokenWeb.verifyCode:this.$route.query.verifyCode,
                    countryCodeData: this.isWeb? this.dataTokenWeb.countryCodeData :this.$route.query.countryCodeData,
                },
                //dialog 用
                dialog: {
                    isShowDialog: false,
                    dialogMsg: '',
                    cancelable: false,
                },
                // line
                dataToken: this.isWeb? this.dataTokenWeb.dataToken : this.$route.params.dataToken,
                isLine: this.isWeb? this.dataTokenWeb.isLine : this.$route.query.isLine,
            }
        },
        created() {

        },
        mounted() {
            try {
                let loginObject = this.$crypto.uriComponentToObject(sessionStorage.getItem('loginToken'));
                this.loginObject = loginObject || '';
            } catch (e) {
                console.log("loginObject catch");
            }
        },
        methods: {

            /** 顯示訊息 dialog */
            showDialog: function (msg, cancelable = false) {
                this.dialog.cancelable = cancelable;
                this.dialog.dialogMsg = msg;
                this.dialog.isShowDialog = true;
            },

            /** CommDialog 關閉事件 */
            onCommDialogClose(result) {
                if(!this.isWeb){
                    //APP、LINE綁定、商圈網頁版用
                    this.dialog.isShowDialog = false;
                    this.$router.go(-2);
                }else {
                    //單店純網頁版用
                    this.$emit('result', false);
                }
            },

            /** 送出 更改密碼 */
            submit() {

                let isNewPasswordMatch = (this.form.password === this.form.reconfirm);

                if (!isNewPasswordMatch) {
                    //錯誤提示
                    this.$store.commit(SHOW_TOAST, "輸入的新密碼不一致");

                } else if (!checkPassword(this.form.password)) {
                    this.$store.commit(SHOW_TOAST, '密碼必須為6-12英文數字混合');

                } else {
                    this.callResetPasswordApi(
                        this.verifyForm.phone,
                        this.form.password,
                        this.verifyForm.verifyCode);
                }
            },

            /** 重設密碼 api */
            callResetPasswordApi(tel, pwd, verifyCode) {
                let code = this.verifyForm.countryCodeData&& this.verifyForm.countryCodeData.code && this.verifyForm.countryCodeData.code !== ""? this.verifyForm.countryCodeData.code : "+886"
                let enName = this.verifyForm.countryCodeData && this.verifyForm.countryCodeData.enName && this.verifyForm.countryCodeData.enName !== "" ? this.verifyForm.countryCodeData.enName : "TW"
                this.$http.fetchWithEncrypt`ForgotPassword${{
                    countryCode: code,
                    countryName: enName,
                    phone: tel,
                    password: pwd,
                    verifyCode: verifyCode
                }} ${json => {
                    if (json.status) {
                        //成功
                        // this.$store.commit(SHOW_TOAST, json.message);
                        if (this.isLine) {
                            sessionStorage.setItem("loginToken", this.$crypto.objectToURIComponent({
                                "usedType": 'Login',
                                "tel": tel,
                                "countryCode": code,
                                "countryName": enName,
                                "password": pwd,
                                "isLine": this.verifyForm.isLine,
                            }))

                            this.$router.push({name: 'Login', query: {dataToken: this.dataToken}})
                        } else {
                            this.showDialog(json.message);
                        }

                    } else {
                        this.$store.commit(SHOW_TOAST, "重設密碼失敗:" + json.message);
                    }
                }}`;
            },
        }
    }
</script>

<style lang="less" scoped src="@/less/login.less"/>

